import { NbJSThemeOptions, DEFAULT_THEME as baseTheme } from '@nebular/theme';

const baseThemeVariables = baseTheme.variables;

export interface ThemeVariables {
  charts: {
    tooltip: {
      bg: string;
      lineColor: string;
      lineWidth: string;
      borderColor: string;
      extraCss: string;
      textColor: string;
      fontWeight: string;
      fontSize: string;
    },
    legend: {
      fontSize: string;
      textColor: string;
    },
    axis: {
      lineColor: string;
      fontSize: string;
      textColor: string;
      yAxisSplitLine: string;
    },
    item: {
      borderColor: string;
      lineStyle: string;
      lineWidth: string;
    },
    lines: {
      lineGradFrom: string;
      lineGradTo: string;
      areaGradFrom: string;
      areaGradTo: string;
      shadowLineDarkBg: string;
    }[]
  }
}

export const DEFAULT_THEME = {
  name: 'default',
  base: 'default',
  variables: {
    charts: {
      tooltip: {
        bg: baseThemeVariables.bg,
        lineColor: 'rgba(0, 0, 0, 0)',
        lineWidth: '0',
        borderColor: baseThemeVariables.border2,
        extraCss: 'border-radius: 10px; padding: .5rem;',
        textColor: baseThemeVariables.fgText,
        fontWeight: 'normal',
        fontSize: '14',
      },
      legend: {
        fontSize: '14',
        textColor: baseThemeVariables.fgText,
      },
      axis: {
        lineColor: baseThemeVariables.border4,
        fontSize: '14',
        textColor: baseThemeVariables.fg,
        axisLineColor: baseThemeVariables.border4,
        yAxisSplitLine: baseThemeVariables?.seperator,
      },
      item: {
        borderColor: baseThemeVariables.border,
        lineStyle: 'solid',
        lineWidth: '4',
      },
      lines: [
        {
          lineGradFrom: baseThemeVariables.primary,
          lineGradTo: baseThemeVariables.primaryLight,
          areaGradFrom: 'rgba(51, 102, 255, 0.2)',
          areaGradTo: '#ffffff',
          shadowLineDarkBg: 'rgba(0, 0, 0, 0)',
        },
        {
          lineGradFrom: baseThemeVariables.success,
          lineGradTo: baseThemeVariables.successLight,
          areaGradFrom: 'rgba(0, 214, 143, 0.2)',
          areaGradTo: '#ffffff',
          shadowLineDarkBg: 'rgba(0, 0, 0, 0)',
        },
        {
          lineGradFrom: baseThemeVariables.info,
          lineGradTo: baseThemeVariables.infoLight,
          areaGradFrom: 'rgba(0, 149, 255, 0.2)',
          areaGradTo: '#ffffff',
          shadowLineDarkBg: 'rgba(0, 0, 0, 0)',
        },
        {
          lineGradFrom: baseThemeVariables.warning,
          lineGradTo: baseThemeVariables.warningLight,
          areaGradFrom: 'rgba(255, 170, 0, 0.2)',
          areaGradTo: '#ffffff',
          shadowLineDarkBg: 'rgba(0, 0, 0, 0)',
        },
        {
          lineGradFrom: baseThemeVariables.danger,
          lineGradTo: baseThemeVariables.dangerLight,
          areaGradFrom: 'rgba(255, 61, 113, 0.2)',
          areaGradTo: '#ffffff',
          shadowLineDarkBg: 'rgba(0, 0, 0, 0)',
        }
      ]
    }
  } as ThemeVariables as unknown,
} as NbJSThemeOptions;
